<ion-content class="bg-color ion-content marketplace-details">
  <div *ngIf="!loader" style="margin-top: 15px;">
    <span class="backbtn" (click)="marketplace()"> <mat-icon class="mat-icon">keyboard_backspace</mat-icon>Back to Results</span>
  </div>

  <div class="listing">
    <mat-card>
      <mat-card-content>
        <div class="flex-container">
          <div class="side">
            <img *ngIf="imageLoaded" [src]="imagePath">
          </div>
          <div *ngIf="loader" class="container">
            <div class="box">
              <div class="skeleton">
                <div class="skeleton-left">
                  <div class="line h17 w50 m10"></div>
                  <div class="line h8 w25"></div>
                  <div class="line h8 w75"></div>
                  <div class="line h8 w75"></div>
                  <div class="line h8 w75"></div>
                </div>
                <div class="skeleton-right">
                  <div class="square"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="main" *ngIf="!loader">
            <h1 style="color: red;">{{catalogObj?.api_business_object}}</h1>
            <p style="color: #3880ff; font-size: 16px; "> By {{catalogObj?.brand?.name}} |
              {{catalogObj?.api_product_name?.product_name}} | {{catalogObj?.category?.name}}</p>
            <span>Type : {{catalogObj?.type?.name}} </span>
            <p style="font-size: 15px; ">Method : {{catalogObj?.api_input_structure?.input?.bizdata_rest?.endpoint_method?.method}} &nbsp;&nbsp; Price & Deal : {{catalogObj?.price?.name}}</p>

            <!-- <mat-divider></mat-divider> -->
            <div style="display: flex;  justify-content: space-between;">
              <h2 style="font-weight: 500;">About this API</h2>
              <button class="integration-btn" (click)="!catalogStatus ? addToCart(catalogObj?.id) : null" [ngClass]="{'default-button': !catalogStatus, 'added-to-cart-button': catalogStatus}" mat-raised-button>
                
                <span class="icon-and-text" style="display: flex;
                align-items: center;
                font-size: 16px;">
                  <!-- <ion-icon name="cart"></ion-icon> -->
                  <mat-icon  id="head_cart_btn" style="overflow: hidden;">shopping_cart</mat-icon>
                  <span>
                    {{ catalogStatus ? 'Added to Cart' : 'Add to Cart' }}
                  </span>
                </span>
              </button>
            </div>

            <div class="container" [class.show]="ApiShow">
              <ul>
                <li>{{catalogObj?.api_description}}</li>
              </ul>
            </div>
            <button *ngIf="catalogObj?.api_description.length>300" style="background: transparent;"
              (click)="ApiShow = !ApiShow">{{ ApiShow ? 'Show less' : 'Show More'
              }}
              <span *ngIf="!ApiShow" class="arrow down"></span>
              <span *ngIf="ApiShow" class="arrow up"></span>
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

  </div>


  <div class="flex-container">
    <div class="test-view">
      <mat-card class="postman-marketplace m-card-main-content">
        <app-postmanui *ngIf="apiCatalogFormType !== undefined" 
          [apiCatalogFormType]="apiCatalogFormType" [catalogueId]="catalogueId">
        </app-postmanui>
      </mat-card>
      <!-- <app-post-man></app-post-man> -->
    </div>

    <div class="video">
      <mat-card style="padding: 16px !important">
        <mat-card-content>
          <iframe _ngcontent-bjq-c363="" frameborder="0" allowfullscreen=""
            src="https://www.youtube.com/embed/5v11weV3AYA?rel=0"></iframe>
        </mat-card-content>
      </mat-card>
    </div>


  </div>
  <div *ngIf="!loader">
    <span class="backbtn" (click)="marketplace()"> <mat-icon class="mat-icon">keyboard_backspace</mat-icon>Back to Results</span>
  </div>
  <div *ngIf="!loader">
    <app-footer></app-footer>
  </div>
</ion-content>